var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isSkipped)?_c('div',{staticClass:"item instruction",class:_vm.addedClasses},[_c('localized',{staticClass:"prompt",attrs:{"locale":_vm.computedLocale,"translate":_vm.prompt}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }